class LinkedProductQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.cartNotification = document.querySelector('cart-notification');
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();
    if (this.button.disabled || this.button.classList.contains('loading')) return;

    const variantId = this.button.dataset.quickAddVariantId;
    if (!variantId) return;

    this.button.classList.add('loading');
    this.button.disabled = true;

    const body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: this.cartNotification ? this.cartNotification.getSectionsToRender().map((section) => section.id) : [],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          console.error(parsedState.description || parsedState.message);
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { sourceElement: this.button } }));
        if (this.cartNotification) this.cartNotification.renderContents(parsedState);
      })
      .catch((error) => console.error('linked-products quick add failed', error))
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.disabled = false;
      });
  }
}

customElements.define('product-linked-quick-add', LinkedProductQuickAdd);
